import { BlockType } from 'blocks/BlockType'
import { baseBlockSchema } from 'blocks/IBaseBlockData'
import { z } from 'zod'

export const dashboardBlockSchema = baseBlockSchema.extend({
  type: z.literal(BlockType.DashboardBlock),
})
